import type { Etat } from '../partage/api/types';
import { MOTS_ETAT } from '../partage/vocabulaire';

/**
 * Les quatre états, dessinés. Le vocabulaire du modèle n'est pas celui de l'écran :
 *
 *   a_faire                 → à faire        cercle vide
 *   en_attente_confirmation → en instruction cercle ambré en pointillé — le monde a la balle
 *   fait                    → acquis         cercle plein, coché
 *   sans_objet              → en réflexion   cercle barré, pâle : une idée, pas encore une tâche
 *
 * L'ambre, jamais le rouge : ce qui attend le monde extérieur n'est pas un retard (principe 3).
 */
export function PastilleEtat({ etat, taille = 18 }: { etat: Etat; taille?: number }) {
  const commun = {
    className: 'pastille-etat',
    width: taille,
    height: taille,
    viewBox: '0 0 16 16',
    fill: 'none',
  } as const;

  switch (etat) {
    case 'fait':
      return (
        <svg {...commun} aria-label={MOTS_ETAT.fait}>
          <circle cx="8" cy="8" r="8" fill="var(--accent)" />
          <path d="M4.3 8.2l2.6 2.6 5-5.4" stroke="#FFFFFF" strokeWidth="1.5" fill="none" />
        </svg>
      );

    case 'en_attente_confirmation':
      return (
        <svg {...commun} aria-label={MOTS_ETAT.en_attente_confirmation}>
          <circle
            cx="8"
            cy="8"
            r="7.2"
            stroke="var(--monde)"
            strokeWidth="1.4"
            strokeDasharray="2.4 2.8"
          />
        </svg>
      );

    case 'sans_objet':
      return (
        <svg {...commun} aria-label={MOTS_ETAT.sans_objet}>
          <circle cx="8" cy="8" r="7.2" stroke="var(--trait-pointille)" strokeWidth="1.4" />
          <path d="M4.6 11.4L11.4 4.6" stroke="var(--trait-pointille)" strokeWidth="1.4" />
        </svg>
      );

    default:
      return (
        <svg {...commun} aria-label={MOTS_ETAT.a_faire}>
          <circle cx="8" cy="8" r="7.2" stroke="var(--trait-marque)" strokeWidth="1.4" />
        </svg>
      );
  }
}
